import type { OptionDB } from "@project/emerge";
import { Sides } from "@project/emerge-types";
import { Box3 } from "three";
import { InteriorType } from "../enum/InteriorType";
import { LTCaseUserOption } from "../enum/LTCaseUserOption";
import { createSingleItemTree } from "../genetic_optimize/ContentTree";
import type {
  AccessoryCompartmentOptions,
  CaseInteriorOptions,
} from "../interfaces/AccessoryCompartmentOptions";
import type { CaseCompartment } from "../interfaces/CaseCompartment";
import { createNewCompartment } from "../structure/Compartment";
import { OptionDBInstance } from "./options_db";

export type PaddingMap = { [side in Sides]: number };

export function createEqualPaddingMap(padding: number): PaddingMap {
  return {
    [Sides.TOP]: padding,
    [Sides.FRONT]: padding,
    [Sides.BACK]: padding,
    [Sides.BOTTOM]: padding,
    [Sides.LEFT]: padding,
    [Sides.RIGHT]: padding,
  };
}

// const sizeWithPadding = size.add(new Vector3(
//     padding[Sides.LEFT] + padding[Sides.RIGHT] + tolerance[0],
//     padding[Sides.BOTTOM] + tolerance[1],
//     padding[Sides.FRONT] + padding[Sides.BACK] + tolerance[2],
// ));
// boxWithPadding: new Box3(
//     sizeWithPadding.clone().multiplyScalar(-0.5),
//     sizeWithPadding.clone().multiplyScalar(.5),
// ),

export function calculateBoxWithPadding(compartment: CaseCompartment): Box3 {
  const { center, sizeWithPadding } = compartment;
  return new Box3().setFromCenterAndSize(center, sizeWithPadding.clone());
}

export function createAccessoryCompartment(
  side: Sides.FRONT | Sides.LEFT | Sides.RIGHT | Sides.BACK = Sides.RIGHT,
  size = 250,
  padding = "nopad",
): AccessoryCompartmentOptions {
  return {
    padding: OptionDBInstance.getByName(LTCaseUserOption.PaddingType, padding),
    side,
    size,
  };
}

export function createCaseInterior(optionDb: OptionDB): CaseInteriorOptions {
  const item = createNewCompartment();
  return {
    tolerance: { x: 7, y: 2, z: 7 },
    trayMaterial: optionDb.getByName(
      LTCaseUserOption.TrayMaterialType,
      "PLW1415",
    ),
    tree: createSingleItemTree(item),
    contents: [item],
    type: InteriorType.CASE,
    upperPaddingAlignment: true,
  };
}
